<template>
  <div class="table-container">
    <vab-query-form>
      <el-form ref="form" :model="queryForm" :inline="true" @submit.native.prevent>
        <el-form-item style="float: right">
          <el-button icon="el-icon-plus" type="primary" @click="handleAdd">
            添加估算详情
          </el-button>
        </el-form-item>
      </el-form>
    </vab-query-form>

    <el-table ref="tableSort" v-loading="listLoading" :data="list" height="73vh" border>
      <!-- 名称 -->
      <el-table-column show-overflow-tooltip prop="name" label="名称" align="center"></el-table-column>
      <el-table-column show-overflow-tooltip label="创建时间" prop="add_time" width="250" align="center"></el-table-column>

      <el-table-column show-overflow-tooltip label="操作面板" width="150px" align="center">
        <template #default="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
          <el-button type="text" @click="handleDel(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加修改管理员对话框 -->
    <el-dialog :title="IsAdd ? '添加估算' : '修改估算'" :visible.sync="dialogVisible" width="50%" :destroy-on-close="true"
      :before-close="handleClose">
      <div>
        <el-form ref="form" :model="addForm" label-width="100px">
          <el-form-item label="标题" prop="name">
            <el-input v-model="addForm.name" maxlength="20" type="text" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="线路" prop="name">
            <el-select v-model="addForm.kor_type" placeholder="请选择">
              <el-option label="韩到日" :value="3"></el-option>
              <el-option label="韩到马来" :value="4"></el-option>
              <el-option label="中到马来" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="内容" prop="name">
            <el-upload class="quill-upload" :http-request="upload" action="#" :show-file-list="false" with-credentials
              accept="image/gif, image/jpeg, image/jpg, image/bmp, image/png" style="display: none">
              <i id="imgInput" class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
            <quill-editor ref="myQuillEditor" v-model="addForm.content" :options="editorOption"
              @change="onEditorChange($event)" />
          </el-form-item>
          <div class="editor-wrapper">

          </div>
          <el-form-item>
            <el-button type="primary" @click="dialogVisible = false">
              取消
            </el-button>
            <el-button type="primary" @click="save">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    Estimate_list,
    Estimate_detail,
    Estimate_update,
    Estimate_del
  } from '@/api/xgcApi'
  import {
    getUploadUrl
  } from '@/config'
  import exoprt_file from '@/utils/expor_file' // 导出excel文件
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote', 'code-block'],

    [{
        header: 1,
      },
      {
        header: 2,
      },
    ], // custom button values
    [{
        list: 'ordered',
      },
      {
        list: 'bullet',
      },
    ],
    [{
        script: 'sub',
      },
      {
        script: 'super',
      },
    ], // superscript/subscript
    [{
        indent: '-1',
      },
      {
        indent: '+1',
      },
    ], // outdent/indent
    [{
      direction: 'rtl',
    }, ], // text direction

    [{
      size: ['small', false, 'large', 'huge'],
    }, ], // custom dropdown
    [{
      header: [1, 2, 3, 4, 5, 6, false],
    }, ],

    [{
        color: [],
      },
      {
        background: [],
      },
    ], // dropdown with defaults from theme
    [{
      font: [],
    }, ],
    [{
      align: [],
    }, ],
    ['clean'], // remove formatting button
    ['image'],
  ]
  export default {
    name: 'ComprehensiveTable',
    components: {},
    filters: {
      statusFilter(status) {
        const statusMap = {
          published: 'success',
          draft: 'gray',
          deleted: 'danger',
        }
        return statusMap[status]
      },
    },
    data() {
      return {
        dialogVisible: false, //添加管理员对话框
        upUrl: '/index/index/file', //上传图片的接口
        IsAdd: true,
        form: {},
        addForm: {},
        list: [],
        listLoading: true,
        selectRows: '',
        editorOption: {
          placeholder: '请输入内容',
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                // 重写点击组件上的图片按钮要执行的代码
                image: function(value) {
                  document
                    .querySelector('.quill-upload .el-upload__input')
                    .click()
                },
              },
            },
          },
        },
        queryForm: {
          page: 1,
          limit: 20,
        },

      }
    },
    computed: {},
    created() {

    },
    mounted() {
      this.fetchData()
    },
    methods: {
      save() {
        var data = {
          ...this.addForm
        }
        Estimate_update(data).then(res => {
          this.dialogVisible = false
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.fetchData()
        })
      },
      upload(file) {
        // 图片上传
        file = file.file
        var data = {
          file: file,
        }
        var url = ''
        exoprt_file(this.upUrl, data).then((res) => {
          var pic = getUploadUrl + res
          let quill = this.$refs.myQuillEditor.quill
          // 获取光标所在位置
          let length = quill.getSelection().index
          // 插入图片 res.url为服务器返回的图片地址
          quill.insertEmbed(length, 'image', pic)
          // 调整光标到最后
          quill.setSelection(length + 1)
          // 调用编辑器的 insertEmbed 方法，插入URL
        })
      },
      handleDel(row) {
        // 删除
        this.$confirm('此操作将永久删除该条信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var data = {id:row.id}
          Estimate_del(data).then(res=>{
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.fetchData()
          })

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      handleAdd() {
        this.IsAdd = true
        this.addForm = {}
        this.dialogVisible = true

      },
      handleClose() {
        this.addForm = {}
        this.dialogVisible = false
      },
      handleEdit(item) {
        this.dialogVisible = true
        this.IsAdd = false
        Estimate_detail({
          id: item.id
        }).then(res => {
          this.addForm = res.data
          this.fetchData()
        })
      },
      fetchData() {
        // 获取列表
        this.listLoading = true
        Estimate_list(this.queryForm).then((res) => {
          this.list = res.data.list
          this.total = res.data.count
          this.listLoading = false
        })
      },
    },
  }
</script>

<style scoped>
  :deep .right-panel {
    display: flex;
    align-items: center;
  }

  .el-switch {
    height: auto !important;
  }
</style>
